/**
 * Tab switching
 */
(function () {
  function refreshCarousel(panel) {
    const carousel = panel?.querySelector('[data-carousel]');
    if (!carousel) return;

    if (typeof carousel._carouselUpdate === 'function') {
      carousel._carouselUpdate();
    } else {
      carousel.dispatchEvent(new CustomEvent('carousel:refresh'));
    }
  }

  document.querySelectorAll('[data-tabs-carousel]').forEach((root) => {
    const tabs = root.querySelectorAll('[data-tab]');
    const panels = root.querySelectorAll('[data-tab-panel]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const index = tab.dataset.tab;
        tabs.forEach((t) => {
          t.classList.toggle('is-active', t.dataset.tab === index);
          t.setAttribute('aria-selected', t.dataset.tab === index ? 'true' : 'false');
        });
        panels.forEach((p) => {
          p.hidden = p.dataset.tabPanel !== index;
        });

        const visiblePanel = root.querySelector(`[data-tab-panel="${index}"]`);
        requestAnimationFrame(() => refreshCarousel(visiblePanel));
      });
    });
  });

  document.querySelectorAll('[data-tab-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const group = trigger.closest('[data-tab-group]');
      if (!group) return;
      const index = trigger.dataset.tabTrigger;
      group.querySelectorAll('[data-tab-trigger]').forEach((t) => t.classList.toggle('is-active', t.dataset.tabTrigger === index));
      group.querySelectorAll('[data-tab-content]').forEach((c) => { c.hidden = c.dataset.tabContent !== index; });
    });
  });
})();
